import { mapChannelGroupFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { AutomaticGainControlChannel } from '../../api/models';
import { AutomaticGainControlChannelFragment } from '../graphql/generated/automatic-gain-control.generated';

export function mapAgcChannelFromSysApi(channel: AutomaticGainControlChannelFragment): AutomaticGainControlChannel {
	const {
		id,
		description: { group, constraints },
		features
	} = channel;
	return {
		id,
		group: mapChannelGroupFromSysApi(group),
		name: channel.features.name?.name,
		description: {
			automaticGainControlRmsSupported: channel.description.features.automaticGainControlRms?.supported ?? false,
			automaticGainControlPeakSupported: channel.description.features.automaticGainControlPeak?.supported ?? false
		},
		features: {
			// FIXME: Replace
			automaticGainControl: features.automaticGainControl || {
				enabled: true,
				maxBoost: 0,
				maxCut: 0,
				targetLevel: 0
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		},
		constraints: {
			automaticGainControl: {
				maxBoostRange: {
					min: constraints.automaticGainControl?.maxBoost.range.min ?? 0,
					max: constraints.automaticGainControl?.maxBoost.range.max ?? 20,
					step: constraints.automaticGainControl?.maxBoost.range.step ?? 0.1
				},
				maxCutRange: {
					min: constraints.automaticGainControl?.maxCut.range.min ?? -20,
					max: constraints.automaticGainControl?.maxCut.range.max ?? 0,
					step: constraints.automaticGainControl?.maxCut.range.step ?? 0.1
				},
				targetLevelRange: {
					min: constraints.automaticGainControl?.targetLevel.range.min ?? -50,
					max: constraints.automaticGainControl?.targetLevel.range.max ?? 0,
					step: constraints.automaticGainControl?.targetLevel.range.step ?? 0.1
				}
			},
			automaticGain: {
				gain: {
					min: constraints.automaticGain?.gain.range.min ?? 20,
					max: constraints.automaticGain?.gain.range.max ?? 20,
					step: constraints.automaticGain?.gain.range.step ?? 5
				}
			}
		}
	};
}
